const statusList = new Map([
	[-2,"Rechazado"],
	[-1,"Cancelado"],
	[0,"Pendiente"],
	[1,"Verificando pago"],
	[2,"Pago parcial"],
	[3,"Pagado"]
])
export default statusList